import { render } from "./LayoutMaster.vue?vue&type=template&id=9ed13de2"
import script from "./LayoutMaster.vue?vue&type=script&lang=js"
export * from "./LayoutMaster.vue?vue&type=script&lang=js"

import "./LayoutMaster.vue?vue&type=style&index=0&id=9ed13de2&lang=css"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__